import { render, staticRenderFns } from "./refresh-message.vue?vue&type=template&id=7d3e571b&"
import script from "./refresh-message.vue?vue&type=script&lang=js&"
export * from "./refresh-message.vue?vue&type=script&lang=js&"
import style0 from "./refresh-message.vue?vue&type=style&index=0&id=7d3e571b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports